import React from 'react';
import SiteCharts from '../../../components/SiteCharts/SiteCharts';
import { saIntraCuHandoverChartConfig } from '../chartConfigs';

interface IntraCuHandoverSaEchartsProps {
  onFullscreenToggle: () => void;
  isFullscreen: boolean;
}

const IntraCuHandoverSaEcharts: React.FC<IntraCuHandoverSaEchartsProps> = ({ onFullscreenToggle, isFullscreen }) => (
  <SiteCharts config={saIntraCuHandoverChartConfig} onFullscreenToggle={onFullscreenToggle} isFullscreen={isFullscreen} />
);

export default IntraCuHandoverSaEcharts;
